import { Dispatch, SetStateAction } from 'react';
import * as R from 'ramda';

import elementIcon from '@atom/components/common/svgIcons/elementIcon.svg';
import { useNavigation } from '@atom/hooks/useNavigation';
import { List } from '@atom/mui';
import { AssetDetailView } from '@atom/types/asset';
import { AssetResult } from '@atom/types/search';
import { getSchemaIconFromSchemaOrAsset } from '@atom/utilities/schemaUtilities';
import { highlightedText } from '@atom/utilities/textDisplayUtilities';

const { ListItemButton, ListItemText } = List;

const styles = {
  listItem: {
    paddingLeft: '1rem',
  },
  icon: {
    marginRight: '1rem',
  },
  primaryTextStyle: {
    fontWeight: 'none',
  },
  elementIcon: {
    paddingLeft: '5px',
  },
};

interface Props {
  query: string;
  result: AssetResult;
  setFocused: Dispatch<SetStateAction<boolean>>;
}

const AssetResultItem = ({ query, result, setFocused }: Props) => {
  const [, { navigate }] = useNavigation();

  const handleNavigate = () => {
    const assetId = result?.isSubItem
      ? R.pathOr('', ['ancestors', 0, 'id'], result)
      : result.id;

    const deepLink = result?.isSubItem
      ? `?activeView=${AssetDetailView.SUB_ITEMS}&elementId=${result.id}`
      : '';

    navigate(`/inventory/${assetId}${deepLink}`);
    setFocused(false);
  };

  const icon = result?.isSubItem ? (
    <img style={styles.elementIcon} src={elementIcon} />
  ) : (
    getSchemaIconFromSchemaOrAsset(result)
  );
  const assetName = highlightedText(query, result.name);
  const ancestorsDisplay = result?.ancestors
    ?.map(ancestor => ancestor?.name)
    .join(' / ');
  const subtext = result?.isSubItem
    ? `${result?.assetType} - ${ancestorsDisplay}`
    : result?.assetType;

  return (
    <ListItemButton
      key={result.id}
      onClick={handleNavigate}
      style={styles.listItem}
    >
      <div style={styles.icon}>{icon}</div>
      <ListItemText
        primary={assetName}
        primaryTextStyle={styles.primaryTextStyle}
        secondary={subtext}
      />
    </ListItemButton>
  );
};

export default AssetResultItem;
